import { Provider, ProviderEntity } from '../../../models/provider';
import { applicationParameters } from '../../../utilities/application-parameters';
import { ProviderDown } from '../ProviderDown/ProviderDown';
import { UnhealthyProvider } from '../UnhealthyProvider/UnhealthyProvider';
import { ProviderTemporaryDisabled } from './ProviderTemporaryDisabled';

type UnstableProviderWarningProps = {
  provider: ProviderEntity;
  onClose: () => void;
  onUserCancel: () => void;
  onBack: () => void;
};

// istanbul ignore next: this component is a switch.
export const UnstableProviderWarning = ({
  provider,
  onClose,
  onUserCancel,
  onBack,
}: UnstableProviderWarningProps) => {
  if (Provider.isDown(provider)) {
    return <ProviderDown redirectHome={onBack} redirectBackToClient={onUserCancel} />;
  }

  if (Provider.isUnhealthy(provider)) {
    return (
      <UnhealthyProvider
        provider={provider}
        onClose={onClose}
        redirectBackToClient={onUserCancel}
        redirectHome={onBack}
      />
    );
  }

  if (Provider.isTemporaryDisabled(provider)) {
    const isProviderPreselected = applicationParameters.get('providerName');

    if (isProviderPreselected) {
      return <ProviderTemporaryDisabled onPrimaryClick={onUserCancel} />;
    }

    return <ProviderTemporaryDisabled onSecondaryClick={onUserCancel} onPrimaryClick={onBack} />;
  }

  throw new Error('Invalid provider status');
};
